import React from "react";
import { Avatar, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { getAvatarPropsByName } from "@helpers";
import { Box } from "@components/base";

interface LockedBy {
  name: string;
}

const LockedBy: React.FC<LockedBy> = ({ name }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ position: "absolute", top: -5, left: -5 }}>
      <Tooltip title={t("forms.fieldLocked", { name })}>
        <Avatar {...getAvatarPropsByName(name)} />
      </Tooltip>
    </Box>
  );
};

export default LockedBy;
